import { Validator } from 'vee-validate'
import SbTransNo from './sbTransNo'
import FwWPNo from './fwWPNo'
import MaidStartDate from './maidStartDate'

export default function install() {
  Validator.extend('sbTransNo', SbTransNo)
  Validator.extend('fwWPNo', FwWPNo)
  Validator.extend('maid_start_date', MaidStartDate)
}
